import React, { Fragment, useState } from "react";
import EATable from "../EATable";
import { DESC } from "../../utils/ArrayUtils";
import WiedervorlageEditDialog from "../betriebsakte/common/WiedervorlageEditDialog";
import { createColumn, createComponentColumn, createDateColumn } from "../../utils/ColumnUtils";
import EATableActionButton from "../tableComponents/EATableActionButton";
import { handleApiException } from "../../services/HttpService";
import { deleteWiedervorlage } from "../../services/WiedervorlagenService";
import { toast } from "react-toastify";
import {confirmDeleteOption} from "../ConfirmationDialog/confirmationDialogOptions";
import {useConfirmation} from "../ConfirmationDialog/ConfirmationDialogProvider";

const id = "wiedervorlageArbeitsliste";

export default function WiedervorlageArbeitsliste({ data, loading, refetch }) {
    const confirm = useConfirmation();
    const [wiedervorlageDlgOpen, setWiedervorlageDlgOpen] = useState(false);
    const [currentWiedervorlage, setCurrentWiedervorlage] = useState({});

    function openEditDlg(row) {
        setCurrentWiedervorlage(row);
        setWiedervorlageDlgOpen(true);
    }

    const columns = [
        createComponentColumn("editColumn", (row, index) => {
            return (
                <div className="gridl" style={{gridTemplateColumns: "repeat(2,min-content)", marginLeft: "8px"}}>
                    <EATableActionButton id={"ab-" + index} iconName="ico-view">
                                            <span
                                                onClick={() => openEditDlg(row)}
                                                className={"w-100"}
                                                style={{
                                                    height: "100%",
                                                    display: "block",
                                                }}
                                            />
                    </EATableActionButton>
                    <EATableActionButton id={"deleteWert-" + index} iconName="ico-delete">
                                            <span
                                                onClick={() => handleDelete(row)}
                                                className={"w-100"}
                                                style={{
                                                    height: "100%",
                                                    display: "block",
                                                }}
                                            />
                    </EATableActionButton>
                </div>
            );
        }),
        createDateColumn("datum", "Datum"),
        createColumn("betriebInfo", "Betrieb"),
        createColumn("betreff", "Betreff"),
    ];

    function handleDelete(wiedervorlage) {
        confirm(
            confirmDeleteOption(
                "die Wiedervorlage",
                () => deleteVorlage(wiedervorlage.id),
                () => {}
            )
        );
    }

    function handleDialogClose(didVorlageChange, navigateAway = false) {
        if (didVorlageChange) {
            deleteVorlage(currentWiedervorlage.id, navigateAway);
        }
        setWiedervorlageDlgOpen(false);
    }

    function deleteVorlage(wiedervorlageId, navigateAway = false) {
        deleteWiedervorlage(wiedervorlageId)
            .then(() => {
                toast.success("Die Wiedervorlage wurde erfolgreich gelöscht.");
                if (!navigateAway) {
                    refetch().catch((e) => handleApiException(e, "Error fetching Wiedervorlage"));
                }
            })
            .catch((e) => handleApiException(e, "Error deleting Wiedervorlage"));
    }

    return (
        <Fragment>
            <EATable
                id={id}
                order={DESC}
                loading={loading}
                columns={columns}
                data={data}
                style={{ marginTop: "var(--vertical-spacing)" }}
            />
            <WiedervorlageEditDialog
                open={wiedervorlageDlgOpen}
                wiedervorlage={currentWiedervorlage}
                onClose={handleDialogClose}
                showGoTo={true}
            />
        </Fragment>
    );
}
